/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiCreatePageMetricsPayloadFromJSON(json) {
    return ApiCreatePageMetricsPayloadFromJSONTyped(json, false);
}
export function ApiCreatePageMetricsPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'averageScrollSpeed': !exists(json, 'averageScrollSpeed') ? undefined : json['averageScrollSpeed'],
        'clsScore': !exists(json, 'clsScore') ? undefined : json['clsScore'],
        'clsValue': !exists(json, 'clsValue') ? undefined : json['clsValue'],
        'fcpScore': !exists(json, 'fcpScore') ? undefined : json['fcpScore'],
        'fcpValue': !exists(json, 'fcpValue') ? undefined : json['fcpValue'],
        'inpScore': !exists(json, 'inpScore') ? undefined : json['inpScore'],
        'inpValue': !exists(json, 'inpValue') ? undefined : json['inpValue'],
        'lcpScore': !exists(json, 'lcpScore') ? undefined : json['lcpScore'],
        'lcpValue': !exists(json, 'lcpValue') ? undefined : json['lcpValue'],
        'scrolledPercentage': !exists(json, 'scrolledPercentage') ? undefined : json['scrolledPercentage'],
        'timeOnPageSeconds': !exists(json, 'timeOnPageSeconds') ? undefined : json['timeOnPageSeconds'],
        'viewedPercentage': !exists(json, 'viewedPercentage') ? undefined : json['viewedPercentage'],
    };
}
export function ApiCreatePageMetricsPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'averageScrollSpeed': value.averageScrollSpeed,
        'clsScore': value.clsScore,
        'clsValue': value.clsValue,
        'fcpScore': value.fcpScore,
        'fcpValue': value.fcpValue,
        'inpScore': value.inpScore,
        'inpValue': value.inpValue,
        'lcpScore': value.lcpScore,
        'lcpValue': value.lcpValue,
        'scrolledPercentage': value.scrolledPercentage,
        'timeOnPageSeconds': value.timeOnPageSeconds,
        'viewedPercentage': value.viewedPercentage,
    };
}
